import React, { Suspense, lazy } from "react";
import { BrowserRouter } from "react-router-dom";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import { AuthProvider } from "./context/AuthContext";
import { SearchProvider } from "./context/SearchContext.js";
import { NotificationProvider } from "./context/NotificationContext.js";
import ScrollToTop from "../src/router/ScrollToTop.js";
import CookieBanner from "./components/CookieBanner.js";
import Loader from "./components/Loader";
import OnboardingAssistant from "./components/OnboardingAssistant";
import GuidedTour from "./components/GuidedTour";
import InstallPrompt from "./components/InstallPrompt";
import { LoadingProvider, useLoading } from "./context/LoadingContext";
import NavigationLoader from "./components/NavigationLoader";
import "./styles/App.css";

const AppContent = () => {
  const { pageLoading } = useLoading();

  return (
    <BrowserRouter>
      <ScrollToTop />
      <NavigationLoader />
      {pageLoading && <Loader message="Yükleniyor..." variant="fullscreen" />}
      <div className="app-layout">
        <Nav />
        <main className="page-content">
          <Suspense fallback={
            <Loader message="Yükleniyor..." variant="fullscreen" />
          }>
            <Router />
          </Suspense>
          <CookieBanner />
          <InstallPrompt />
          <OnboardingAssistant />
          <GuidedTour />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

// Lazy load the Router to split code by routes
const Router = lazy(() => import("./router/Router"));

function App() {
  return (
    <AuthProvider>
      <SearchProvider>
        <NotificationProvider>
          <LoadingProvider>
            <AppContent />
          </LoadingProvider>
        </NotificationProvider>
      </SearchProvider>
    </AuthProvider>
  );
}

export default App;

// Force rebuild: 2026-05-03 09:23
